import { render, staticRenderFns } from "./FeaturePanel.vue?vue&type=template&id=01ea3cb0"
import script from "./FeaturePanel.vue?vue&type=script&lang=js"
export * from "./FeaturePanel.vue?vue&type=script&lang=js"
import style0 from "./FeaturePanel.vue?vue&type=style&index=0&id=01ea3cb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports